"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_mask_input_1 = __importStar(require("react-native-mask-input"));
const IC_calender_1 = __importDefault(require("../../../../assets/icons/IC_calender"));
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const scale_1 = require("../../../../utils/scale");
const ModalDatePicker_1 = __importDefault(require("./ModalDatePicker"));
const InputView = (props) => {
    const { errorMessage, onChange } = props;
    const [text, setText] = (0, react_1.useState)('');
    const [datePickerVisible, setDatePickerVisible] = (0, react_1.useState)(false);
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    return (react_1.default.createElement(react_native_1.View, { style: styles.inputContainer },
        react_1.default.createElement(CustomText_1.default, { style: styles.inputTitle }, "\u751F\u5E74\u6708\u65E5"),
        react_1.default.createElement(react_native_1.View, { style: [styles.inputBody,
                !!errorMessage && { borderColor: '#F80F63', backgroundColor: '#FDF3F3' },
                isFocused && { borderColor: '#00AEEF', backgroundColor: '#FEFEFE' }] },
            react_1.default.createElement(react_native_mask_input_1.default, { value: text, placeholder: "\u5E74 / \u6708 / \u65E5", placeholderTextColor: "#292A33", style: styles.textInput, onChangeText: (_masked, unmasked) => {
                    setText(unmasked);
                    onChange(_masked);
                }, mask: react_native_mask_input_1.Masks.DATE_YYYYMMDD, onFocus: handleFocus, onBlur: handleBlur }),
            react_1.default.createElement(react_native_1.Pressable, { onPress: () => setDatePickerVisible(true) },
                react_1.default.createElement(IC_calender_1.default, { width: (0, scale_1.scale)(23), height: (0, scale_1.scale)(23) }))),
        !!errorMessage && (react_1.default.createElement(CustomText_1.default, { style: styles.textError }, errorMessage)),
        react_1.default.createElement(ModalDatePicker_1.default, { visible: datePickerVisible, onClose: () => setDatePickerVisible(false), onSelected: (date) => {
                onChange(date);
                setText(date.replace(/\//g, ''));
                setDatePickerVisible(false);
            } })));
};
exports.default = InputView;
const styles = react_native_1.StyleSheet.create({
    inputContainer: {
        width: '100%',
        marginTop: (0, scale_1.scale)(24),
    },
    inputTitle: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    inputBody: {
        width: '100%',
        marginTop: (0, scale_1.scale)(8),
        flexDirection: 'row',
        borderWidth: (0, scale_1.scale)(1),
        borderRadius: (0, scale_1.scale)(3),
        borderColor: '#C8C8C8',
        paddingHorizontal: (0, scale_1.scale)(10),
        paddingVertical: (0, scale_1.scale)(8.5),
        backgroundColor: '#FEFEFE',
    },
    textInput: {
        height: (0, scale_1.scale)(24),
        fontSize: (0, scale_1.moderateScale)(15),
        fontFamily: 'Hiragino Kaku Gothic Pro W3',
        padding: 0,
        color: '#292A33',
        flex: 1,
        outlineWidth: 0,
    },
    textError: {
        color: '#F80F63',
        fontSize: (0, scale_1.moderateScale)(12),
        marginTop: (0, scale_1.scale)(8),
        lineHeight: (0, scale_1.scale)(16),
    },
});
